import { BuiltinInterface } from '../../BuiltinInterface';
import { BuiltinValueObject } from '../../BuiltinValueObject';
import { LinkedSmartContractFor } from './for';
class LinkedSmartContractValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'LinkedSmartContractConstructor';
    }
}
class LinkedSmartContractConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addContractValue('LinkedSmartContract', new LinkedSmartContractValue());
    builtins.addContractInterface('LinkedSmartContractConstructor', new LinkedSmartContractConstructorInterface());
    builtins.addContractMember('LinkedSmartContractConstructor', 'for', new LinkedSmartContractFor());
};

//# sourceMappingURL=index.js.map
